import React from "react";

const IconPlus = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={34}
      height={35}
      viewBox="0 0 34 35"
      fill="none"
      {...props}
    >
      <path
        d="M29.6738 17.6934C29.6738 17.9725 29.5629 18.2402 29.3656 18.4376C29.1682 18.635 28.9005 18.7458 28.6213 18.7458H18.0964V29.2708C18.0964 29.5499 17.9855 29.8176 17.7882 30.015C17.5908 30.2124 17.3231 30.3232 17.0439 30.3232C16.7648 30.3232 16.4971 30.2124 16.2997 30.015C16.1023 29.8176 15.9915 29.5499 15.9915 29.2708V18.7458H5.46655C5.18741 18.7458 4.91971 18.635 4.72233 18.4376C4.52495 18.2402 4.41406 17.9725 4.41406 17.6934C4.41406 17.4142 4.52495 17.1465 4.72233 16.9491C4.91971 16.7518 5.18741 16.6409 5.46655 16.6409H15.9915V6.11597C15.9915 5.83683 16.1023 5.56912 16.2997 5.37174C16.4971 5.17436 16.7648 5.06348 17.0439 5.06348C17.3231 5.06348 17.5908 5.17436 17.7882 5.37174C17.9855 5.56912 18.0964 5.83683 18.0964 6.11597V16.6409H28.6213C28.9005 16.6409 29.1682 16.7518 29.3656 16.9491C29.5629 17.1465 29.6738 17.4142 29.6738 17.6934Z"
        fill="#FDF2DE"
      />
    </svg>
  );
};

export default IconPlus;
